package com.milta.core.localization.translations.en

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Scan a document",
    reviewTitle = "Review the data",
    fileSentSuffix = "just sent",
    analysingTitle = "Reading the document…",
    analysingSubtitle = "We're detecting the deliveries on the photo. It only takes a few seconds.",
    deliveriesDetectedSuffix = "deliveries detected",
    toCompleteSuffix = "to complete",
    reviewHint = "Complete the flagged deliveries before adding them to the route",
    addressMissingWarning = "Missing address",
    nameMissingWarning = "Missing name",
    recipientMissingPlaceholder = "Recipient not detected",
    phoneNotDetectedNote = "Phone not detected — doesn't block adding",
    deadlineLabelPrefix = "Deadline",
    completeLinkLabel = "Complete",
    addToRouteButtonPrefix = "Add to the route",
    correctionRecipientLabel = "Recipient",
    correctionAddressLabel = "Address",
    correctionPhoneLabel = "Phone",
    correctionDeadlineLabel = "Deadline",
    unreadableTitle = "Unreadable photo.",
    unreadableMessage = "We didn't detect any delivery on this image — retake a well-framed, well-lit photo.",
    retakePhotoButton = "Retake a photo",
    manualEntryButton = "Enter manually",
    rateLimitTitle = "Too many scans done recently.",
    rateLimitMessage = "Try again a bit later, or complete this delivery manually in the meantime.",
    rateLimitRetakeUnavailableLabel = "Retake a photo — unavailable for now",
)
